import { sampleSize} from '@/functional/sampleSize';

export const sampleSizeWithMaxNumberOfElements = (arr, n) => {
    return sampleSize(arr, n && n <= arr.length ? n : arr.length);
};
